export const ORGANIZATIONS_URL = '/organization/v2/organizations';
export const USERS_URL = '/organization/v2/users';
export const ADMIN_URL = '/admin/v2';
